// messagingConfig.js
import { initializeApp } from "firebase/app";
import firebaseConfig from "../firebaseConfig";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { db } from "@/main";
import { doc, setDoc, updateDoc, deleteField } from "firebase/firestore";
import { getMessaging, getToken, deleteToken, onMessage } from "firebase/messaging";
import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
// AJOUT : Import du router pour la navigation
import router from "@/router";

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

// AJOUT : Fonction pour gérer les deep links
const handleNotificationClick = (data) => {
    console.log("Données de notification reçues :", data);
    
    try {
        // Gestion des différents types de navigation
        
        // 1. Navigation vers un chapitre spécifique
      if (data.route === "/bookChapters" && data.bookId) {
    router.push({
        name: "book-chapters",
        params: { 
            id: data.bookId,
        }
    });
} else if (data.route === "/bookSms" && data.bookId) {
    router.push({
        name: "book-sms",
        params: { 
            id: data.bookId,
        }
    });
}  else {
    router.push("/");
}
        
        // OPTIONNEL : Logger l'événement pour Analytics
        // logEvent(analytics, 'notification_clicked', {
        //     book_id: data.bookId,
        //     chapter_id: data.chapterId,
        //     route: data.route,
        //     screen: data.screen,
        //     notification_type: data.chapterId ? 'chapter' : 'book'
        // });
        
    } catch (error) {
        console.error("Erreur lors de la navigation :", error);
        // Fallback vers l'accueil en cas d'erreur
        router.push("/");
    }
};

// Fonction pour demander l'autorisation et récupérer le token
export const requestPermission = async () => {
    try {
        if (Capacitor.isNativePlatform()) {
            // Gestion des notifications pour mobile
            const permStatus = await PushNotifications.requestPermissions();

            if (permStatus.receive === "granted") {
                console.log("Permission de notification accordée.");

                // Enregistrez le service de notification
                await PushNotifications.register();

                PushNotifications.addListener("registration", async (token) => {
                    console.log("Token d'inscription reçu :", token.value);

                    const auth = getAuth();
                    const user = auth.currentUser;

                    if (user) {
                        const userId = user.uid;

                        // Stocker le token dans Firestore
                        await setDoc(
                            doc(db, "users", userId),
                            {
                                fcmToken: token.value,
                                isOnline: true,
                                notificationAccepted: true,
                            },
                            { merge: true }
                        );
                    } else {
                        console.log("Aucun utilisateur connecté.");
                    }
                });

                PushNotifications.addListener("registrationError", (error) => {
                    console.error("Erreur lors de l'enregistrement :", error);
                });
            } else {
                console.error("Permission de notification refusée sur mobile.");
            }
        } else {
            // Gestion des notifications pour le web
            if (!("Notification" in window)) {
                console.error("Ce navigateur ne supporte pas les notifications.");
                return;
            }

            const permission = await Notification.requestPermission();

            if (permission === "granted") {
                const currentToken = await getToken(messaging, {
                    vapidKey: "BEgXoJzxbYJD9BPs9rGOcMw4520RU3jnf80hqVvlsCx1l-kWFyVbVA78hJxYnieDLN6p3p2HnuxCoFtekZVXTMQ",
                });

                if (currentToken) {
                    console.log("Token reçu :", currentToken);

                    const auth = getAuth();
                    const user = auth.currentUser;

                    if (user) {
                        const userId = user.uid;

                        // Stocker le token dans Firestore
                        await setDoc(
                            doc(db, "users", userId),
                            {
                                fcmToken: currentToken,
                                isOnline: true,
                                notificationAccepted: true,
                            },
                            { merge: true }
                        );
                    } else {
                        console.log("Aucun utilisateur connecté.");
                    }
                } else {
                    console.log("Pas de token disponible.");
                }
            } else if (permission === "denied") {
                console.error("L'utilisateur a refusé les notifications.");
            } else {
                console.error("Les notifications sont bloquées.");
            }
        }
    } catch (error) {
        console.error("Erreur lors de la récupération du token :", error);
    }
};

// Fonction pour supprimer le token à la déconnexion
export const removeTokenOnLogout = async () => {
    try {
        const auth = getAuth();
        const user = auth.currentUser;

        if (user) {
            const userId = user.uid;

            // Supprimer le token dans Firestore
            await updateDoc(doc(db, "users", userId), {
                fcmToken: deleteField(),
                isOnline: false,
            });

            // Supprimer le token localement
            await deleteToken(messaging);
            console.log("Token supprimé avec succès.");
        }
    } catch (error) {
        console.error("Erreur lors de la suppression du token :", error);
    }
};

// Vérification des tokens obsolètes
export const validateTokens = async () => {
    const auth = getAuth();

    onAuthStateChanged(auth, async (user) => {
        if (user) {
            const userId = user.uid;
            const token = await getToken(messaging);

            // Vérifier si le token est valide
            if (!token) {
                console.warn(`Le token pour l'utilisateur ${userId} est invalide ou expiré.`);
                await updateDoc(doc(db, "users", userId), {
                    fcmToken: deleteField(),
                });
            }
        }
    });
};

// MODIFICATION : Gestion des notifications sur mobile avec deep links
if (Capacitor.isNativePlatform()) {
    PushNotifications.addListener("pushNotificationReceived", (notification) => {
        console.log("Notification reçue :", notification);
        // Vous pouvez ajouter ici une logique pour afficher la notification
        // même quand l'app est ouverte
    });

    // MODIFICATION PRINCIPALE : Gérer le clic sur la notification
    PushNotifications.addListener("pushNotificationActionPerformed", (action) => {
        console.log("Action de notification effectuée :", action);
        
        // Extraire les données de la notification
        const notificationData = action.notification.data;
        
        // Appeler la fonction de gestion des deep links
        if (notificationData) {
            handleNotificationClick(notificationData);
        }
    });
}

// AJOUT : Gestion des notifications web avec deep links
if (!Capacitor.isNativePlatform()) {
    // Pour les notifications web, utiliser onMessage pour les notifications
    // reçues quand l'app est ouverte
    onMessage(messaging, (payload) => {
        console.log("Message reçu en foreground :", payload);
        
        // Créer une notification personnalisée si nécessaire
        if (payload.notification) {
            const notification = new Notification(payload.notification.title, {
                body: payload.notification.body,
                icon: payload.notification.icon || '/favicon.ico',
                data: payload.data // Les données custom
            });
            
            // Gérer le clic sur la notification web
            notification.onclick = function(event) {
                event.preventDefault();
                window.focus(); // Mettre le focus sur la fenêtre
                
                // Fermer la notification
                notification.close();
                
                // Naviguer vers la page appropriée
                if (payload.data) {
                    handleNotificationClick(payload.data);
                }
            };
        }
    });
}

export { messaging, handleNotificationClick };


// // messagingConfig.js
    
    
    
    
// //export { messaging };
// import { initializeApp } from "firebase/app";
// import firebaseConfig from "../firebaseConfig";
// import { getAuth, onAuthStateChanged } from "firebase/auth"; // Pour obtenir le userId de l'utilisateur connecté
// import { db } from "@/main"; // Importez `db` depuis le fichier main.js
// import { doc, setDoc, updateDoc, deleteField } from "firebase/firestore";
// import { getMessaging, getToken, deleteToken } from "firebase/messaging"; // Ajout de deleteToken
// import { Capacitor } from "@capacitor/core";
// import { PushNotifications } from "@capacitor/push-notifications";

// const firebaseApp = initializeApp(firebaseConfig);
// const messaging = getMessaging(firebaseApp);

// // Fonction pour demander l'autorisation et récupérer le token
// export const requestPermission = async () => {
//     try {
//         if (Capacitor.isNativePlatform()) {
//             // Gestion des notifications pour mobile
//             const permStatus = await PushNotifications.requestPermissions();

//             if (permStatus.receive === "granted") {
//                 // console.log("Permission de notification accordée.");

//                 // Enregistrez le service de notification
//                 await PushNotifications.register();

//                 PushNotifications.addListener("registration", async (token) => {
//                     // console.log("Token d'inscription reçu :", token.value);

//                     const auth = getAuth();
//                     const user = auth.currentUser;

//                     if (user) {
//                         const userId = user.uid;

//                         // Stocker le token dans Firestore
//                         await setDoc(
//                             doc(db, "users", userId),
//                             {
//                                 fcmToken: token.value,
//                                 isOnline: true,
//                                 notificationAccepted: true,
//                             },
//                             { merge: true }
//                         );
//                     } else {
//                         // console.log("Aucun utilisateur connecté.");
//                     }
//                 });

//                 PushNotifications.addListener("registrationError", () => {
//                     // console.error("Erreur lors de l'enregistrement :", error);
//                 });
//             } else {
//                 // console.error("Permission de notification refusée sur mobile.");
//             }
//         } else {
//             // Gestion des notifications pour le web
//             if (!("Notification" in window)) {
//                 // console.error("Ce navigateur ne supporte pas les notifications.");
//                 return;
//             }

//             const permission = await Notification.requestPermission();

//             if (permission === "granted") {
//                 const currentToken = await getToken(messaging, {
//                     vapidKey: "BEgXoJzxbYJD9BPs9rGOcMw4520RU3jnf80hqVvlsCx1l-kWFyVbVA78hJxYnieDLN6p3p2HnuxCoFtekZVXTMQ",
//                 });

//                 if (currentToken) {
//                     // console.log("Token reçu :", currentToken);

//                     const auth = getAuth();
//                     const user = auth.currentUser;

//                     if (user) {
//                         const userId = user.uid;

//                         // Stocker le token dans Firestore
//                         await setDoc(
//                             doc(db, "users", userId),
//                             {
//                                 fcmToken: currentToken,
//                                 isOnline: true,
//                                 notificationAccepted: true,
//                             },
//                             { merge: true }
//                         );
//                     } else {
//                         // console.log("Aucun utilisateur connecté.");
//                     }
//                 } else {
//                     // console.log("Pas de token disponible.");
//                 }
//             } else if (permission === "denied") {
//                 // console.error("L'utilisateur a refusé les notifications.");
//             } else {
//                 // console.error("Les notifications sont bloquées.");
//             }
//         }
//     } catch (error) {
//         // console.error("Erreur lors de la récupération du token :", error);
//     }
// };

// // Fonction pour supprimer le token à la déconnexion
// export const removeTokenOnLogout = async () => {
//     try {
//         const auth = getAuth();
//         const user = auth.currentUser;

//         if (user) {
//             const userId = user.uid;

//             // Supprimer le token dans Firestore
//             await updateDoc(doc(db, "users", userId), {
//                 fcmToken: deleteField(),
//                 isOnline: false,
//             });

//             // Supprimer le token localement
//             await deleteToken(messaging);
//             // console.log("Token supprimé avec succès.");
//         }
//     } catch (error) {
//         // console.error("Erreur lors de la suppression du token :", error);
//     }
// };

// // Vérification des tokens obsolètes
// export const validateTokens = async () => {
//     const auth = getAuth();

//     onAuthStateChanged(auth, async (user) => {
//         if (user) {
//             const userId = user.uid;
//             const token = await getToken(messaging);

//             // Vérifier si le token est valide
//             if (!token) {
//                 // console.warn(`Le token pour l'utilisateur ${userId} est invalide ou expiré.`);
//                 await updateDoc(doc(db, "users", userId), {
//                     fcmToken: deleteField(),
//                 });
//             }
//         }
//     });
// };

// // Gestion des notifications sur mobile
// if (Capacitor.isNativePlatform()) {
//     PushNotifications.addListener("pushNotificationReceived", (notification) => {
//         console.log("Notification reçue :", notification);
//     });

//     PushNotifications.addListener("pushNotificationActionPerformed", (action) => {
//         console.log("Action de notification effectuée :", action);
//     });
// }

// export { messaging };
